import React from 'react';
import {
  BarChart3,
  Building2,
  Clock,
  Database,
  DollarSign,
  Target,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  dollar: DollarSign,
  clock: Clock,
  database: Database,
  target: Target,
  chart: BarChart3,
  building: Building2,
};

export const WhyAgencyBenefitIcon: React.FC<{ icon: string }> = ({ icon }) => {
  const Icon = ICONS[icon] ?? DollarSign;
  return <Icon className="home-membership__benefit-icon" aria-hidden="true" strokeWidth={1.75} />;
};

export default WhyAgencyBenefitIcon;
